export interface PopupCode {
    html: string;
    css: string;
}

export const isAiPopupHtml = (html: string): boolean => /<div\b[^>]*\bdata-webixty-ai-popup\s*=/i.test(html);

export const popupDocument = ({ html, css }: PopupCode, language = 'bg'): string => {
    const lang = /^[a-z]{2,3}(?:-[a-z0-9]+)*$/i.test(language) ? language : 'bg';
    const safeCss = css.replace(/<\/style/gi, '<\\/style');
    return `<!doctype html><html lang="${lang}"><head><meta charset="utf-8"><meta name="viewport" content="width=device-width, initial-scale=1"><meta http-equiv="Content-Security-Policy" content="default-src 'none'; img-src https: http: data:; style-src 'unsafe-inline'; base-uri 'none'; form-action 'none'"><style>html{color-scheme:light}body{margin:0;font:16px/1.5 system-ui,sans-serif;color:#1f2937;overflow-wrap:anywhere}*,*::before,*::after{box-sizing:border-box}img{max-width:100%;height:auto}${safeCss}</style></head><body>${html}</body></html>`;
};
